import { fetcher, endpoints, poster } from '../utils/axios';

/**
 * Get applicants list
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameter is 'id' of the job
 * @return {Promise} Promise resolving to an object containing the list of applicants
 */
export async function getApplicantsList(payload) {
    const URL = endpoints.admin.getApplicantsList;
    return await fetcher([URL, { params: payload }])
}
/**
 * Get applicant rating
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameter is 'id' of the application
 * @return {Promise} Promise resolving to an object containing the rating of the applicant
 */
export async function getApplicantRating(payload) {
    const URL = endpoints.admin.getApplicationRating;
    return await poster([URL, payload])
}


/**
 * Get candidate list
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameter is 'id' of the company
 * @return {Promise} Promise resolving to an object containing the list of candidates
 */
export async function getCandidateList(payload) {
    const URL = endpoints.admin.getCandidateList;
    return await fetcher([URL, { params: payload }])
}

/**
 * Get candidate applications
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameter is 'id' of the candidate
 * @return {Promise} Promise resolving to an object containing the list of applications
 */
export async function getCandidateApplications(payload) {
    const URL = endpoints.admin.getCandidateApplications;
    return await fetcher([URL, { params: payload }])
}

/**
 * Get candidate information
 * @param {Object} payload - Payload containing parameters,
 *                           the required parameter is 'id' of the candidate
 * @return {Promise} Promise resolving to an object containing the candidate's information
 */

export async function getCandidateInfo(payload) {
    const URL = endpoints.admin.getCandidateInfo;
    return await fetcher([URL, { params: payload }])
}

/**
 * Set application status
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameters are 'applicationId' and 'status'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function setApplicationStatus(payload) {
    const URL = endpoints.admin.setApplicationStatus;
    return await poster([URL, payload])
}

/**
 * Set feedback details
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameter is 'feedback'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function setFeedbackDetails(payload) {
    const URL = endpoints.admin.setFeedbackDetails;
    return await poster([URL, payload])
}
/**
 * Update shared applicant
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameters are 'applicationId' and 'sharedApplicant'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function updateSharedApplicant(payload) {
    const URL = endpoints.admin.updateSharedApplicant;
    return await poster([URL, payload])
}

/**
 * Delete feedback
 * @param {Object} payload - Payload containing parameters, 
 *                           the required parameter is 'feedbackId'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function deleteFeedback(payload) {
    const URL = endpoints.admin.deleteFeedback;
    return await poster([URL, payload])
}

/**
 * Update candidate status
 * @param {Object} payload - Payload containing parameters,
 *                           the required parameter is 'candidateId' and 'status'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function updateCandidateStatus(payload) {
    const URL = endpoints.admin.updateCandidateStatus;
    return await poster([URL, payload])
}

/**
 * Get candidate status summary
 * @return {Promise} Promise resolving to an object containing the candidate status summary with job search status and communication frequency
 */
export async function getCandidateStatusSummary() {
    const URL = endpoints.admin.getCandidateStatusSummary;
    return await fetcher([URL])
}

